export default "__VITE_ASSET__fYmunViu__"